<template>
  <b-card>
    <div style="margin-bottom: 30px">
      <span>本单位在岗人数{{ workStudentCount }}人，上报考核人数{{ submitStudentCount }}人；上报薪资总额：
        <!--{{submitMoney}}(备注：越过用工单位不存在上报薪资总额)-->--元</span>
      <el-button v-if="this.tableData.length !== 0" type="primary" style="float: right" @click="checkFinish">
        提交
      </el-button>
      <el-button v-if="this.tableData.length !== 0" :disabled="limitTotrueFlag" type="text" style="float: right;margin-right:20px;" @click="limitTotrueSalary">
        将月工资上限填充至当月实际工资
      </el-button>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" />
        <el-table-column prop="jobName" label="岗位名称" />
        <el-table-column prop="studentName" label="姓名" />
        <el-table-column prop="sn" label="学号" />
        <el-table-column prop="yearMonthStr" label="统计年月" />
        <el-table-column prop="timeStr" label="工作时间段" />
        <el-table-column prop="hourMoney" label="月薪" />
        <el-table-column prop="monthMoneyCap" label="月工资上限">
          <template slot-scope="scope">
            {{ scope.row.monthMoneyCap&&scope.row.monthMoneyCap!=='null'?scope.row.monthMoneyCap:'--' }}
          </template>
        </el-table-column>
        <el-table-column prop="submitMoney" label="拟发放工资">
          <template slot-scope="scope">
            {{ scope.row.submitMoney?scope.row.submitMoney:'--' }}
          </template>
        </el-table-column>
        <el-table-column label="当月实际工资">
          <template slot-scope="scope">
            <el-input v-if="scope.row.checkStatus === 0" v-model="scope.row.realMoney" style="width: 100px" @blur="saveStudent(scope.row)" @focus="changeTextButton(scope.row)" />
            <span v-else>{{ scope.row.realMoney?scope.row.realMoney:'--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="10" layout="total, prev, pager, next" :total="totalPages">
      </el-pagination> -->
    </div>
  </b-card></template>

<script>
import { salaryService } from '@/api/index'
import { intZ } from '@/tool/utils'

export default {
  name: 'ProvideDetail',
  data() {
    return {
      limitTotrueFlag: false,
      tableData: [],
      currentPage: 1,
      totalPages: 0,
      id: null,
      time: null,
      submitMoney: null,
      submitStudentCount: null,
      workStudentCount: null,
      checkStatus: null,
    }
  },
  watch: {
    currentPage() {
      this.changeTextButton()
    },
  },
  created() {
    this.id = this.$route.query.id
    this.time = this.$route.query.time
    this.initPage()
  },
  methods: {
    initPage() {
      salaryService()._studentSalaryListIn(
        {
          // page: this.currentPage,
          // size: 10,
          unitId: this.id,
          time: this.time,
        },
      ).then(res => {
        if (res.status) {
          this.tableData = res.data.list
          this.totalPages = res.data.total
          this.submitMoney = res.data.unitSalary.submitMoney
          this.submitStudentCount = res.data.unitSalary.submitStudentCount
          this.workStudentCount = res.data.unitSalary.workStudentCount
          this.checkStatus = res.data.checkStatus
        }
      })
    },
    // 将月工资上限填充至当月实际工资
    limitTotrueSalary() {
      this.$confirm('当前实际工资将被覆盖，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.forEach(item => {
          item.realMoney = item.monthMoneyCap
          if (item.realMoney) {
            this.saveStudent(item)
          }
        })
        this.limitTotrueFlag = true
      }).catch(() => {

      })
    },
    // 输入框值有变动时切换文字按钮状态
    changeTextButton() {
      // debugger
      this.limitTotrueFlag = false
      // if (rowVal.realMoney !== rowVal.monthMoneyCap) {
      //   this.limitTotrueFlag = false
      // } else {
      //   this.limitTotrueFlag = true
      // }
    },
    // 提交--其实就是审核完成
    checkFinish() {
      if (this.tableData.length !== 0) {
        const submitFlag = this.tableData.filter(item => !item.realMoney)
        const params = {
          unitId: this.id,
          time: this.time,
          checkStatus: 0,
          // page: this.currentPage,
          // size: 10
        }
        if (submitFlag.length === 0) {
          salaryService()._salaryFinishCheck(params).then(res => {
            if (res.status) {
              this.$message.success('提交成功，请在月报酬发放审批模块中查看或导出当前填写的数据')
              this.currentPage = 1
              this.initPage()
            }
          })
        } else {
          this.$message.warning('请填写完所有人的当月实际工资！')
        }
      } else {
        this.$message.warning('无数据可提交！')
      }
    },
    // eslint-disable-next-line consistent-return
    saveStudent(row) {
      if (intZ(row.realMoney)) {
        const params = {
          id: row.id,
          realMoney: Number(row.realMoney),
        }
        salaryService()._saveStudentSalaryTemp(params)
      } else {
        row.realMoney = null
        this.$message.warning('请输入正整数（可含零）')
        return false
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initPage()
    },
  },
}
</script>

<style>

</style>
